import React from "react";
import { Table, Tbody, Td, Th, Thead, Tr } from "react-super-responsive-table";
import TableLoader from "../LoadingSpinner/LoadingSpinner";
import LotiFiles from "../Lotifiles/LotiFiles";
import { useNavigate } from "react-router-dom";

const TransactionMonth = ({ isLoading, month_payment_list, state }) => {
  const navigate = useNavigate();

  let total_paid_amount = 0;
  let total_expenses_amount = 0;

  for (let i = 0; i < month_payment_list?.list?.length; i++) {
    total_paid_amount += month_payment_list?.list[i]?.paid_amount;
  }
  for (let i = 0; i < month_payment_list?.list?.length; i++) {
    total_expenses_amount += month_payment_list?.list[i]?.expenses_amount;
  }
  return (
    <div>
      <div className="payment-middle">
        <span className="payment-top-left-title">MONTHLY TRANSACTION</span>
      </div>
      <div>
        <div className="ex-content-middle">
          {isLoading ? (
            <TableLoader />
          ) : month_payment_list?.list?.length > 0 ? (
            <div className="cat-content-middle">
              <Table className="content-middle-main">
                <Thead>
                  <Tr>
                    <Th className="content-middle-title-tr">
                      Months [{state.year}]
                    </Th>
                    <Th className="content-middle-title-tr">Income</Th>
                    <Th className="content-middle-title-tr">Expense</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {month_payment_list && month_payment_list?.list?.length > 0
                    ? month_payment_list?.list?.map((item, index) => {
                        return (
                          <Tr>
                            <Td
                              className="content-middle-mobile-data customer-name"
                              onClick={() => {
                                navigate(
                                  "/transaction-year/transaction-month/transaction-day",
                                  {
                                    state: {
                                      month: item.month,
                                      year: state.year,
                                    },
                                  }
                                );
                              }}
                            >
                              {item?.month !== "" ? item.month : "-"}
                            </Td>
                            <Td
                              className="content-middle-mobile-data"
                              style={{ color: "#00D100", fontWeight: "bold" }}
                            >
                              {item?.paid_amount !== ""
                                ? item?.paid_amount?.toFixed(2)
                                : "-"}
                            </Td>
                            <Td
                              className="content-middle-mobile-data"
                              style={{ color: "#D10000", fontWeight: "bold" }}
                            >
                              {item?.expenses_amount !== ""
                                ? item.expenses_amount?.toFixed(2)
                                : "-"}
                            </Td>
                          </Tr>
                        );
                      })
                    : null}
                  <Tr
                    style={{
                      fontWeight: "bold",
                      backgroundColor: "#FFD68A",
                      marginTop: "1px",
                    }}
                  >
                    <Td
                      className="cat-content-middle-name-data"
                      style={{
                        fontSize: "20px",
                      }}
                    >
                      TOTAL
                    </Td>
                    <Td
                      className="cat-content-middle-name-data"
                      style={{
                        color: "#00D100",
                        fontWeight: "bold",
                        fontSize: "20px",
                      }}
                    >
                      {total_paid_amount?.toFixed(2)}
                    </Td>
                    <Td
                      className="cat-content-middle-name-data"
                      style={{
                        color: "#D10000",
                        fontWeight: "bold",
                        fontSize: "20px",
                      }}
                    >
                      {total_expenses_amount?.toFixed(2)}
                    </Td>
                  </Tr>
                </Tbody>
              </Table>
            </div>
          ) : (
            <LotiFiles message={"No Expenses!!!"} />
          )}
        </div>
      </div>
    </div>
  );
};

export default TransactionMonth;
